import { OlCoachCompanyCreatePage } from '../../components/pages/ols/coach-companies/coach-company-create'
import OlTeachingHallView from '../../components/pages/ols/teaching-halls/ol-teaching-hall-view'
import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import OlCenterDetails from './center/ol-center-details'
import OlCenterListPage from './center/ol-center-list'
import OLCoachCompaniesGlobalListPage from './coach-companies/coach-companies-global-list'
import OLHostFamilyGlobalListPage from './host-families/host-families-global-list'
import OlActivityViewPage from './ol-activity-view'
import OlCoachCompaniesViewPage from './ol-coach-companies-view'
import OlCommissionCreatePage from './ol-commission-create'
import OlCommissionListPage from './ol-commission-list'
import OlCommissionUpdatePage from './ol-commission-update'
import OlCreatePage from './ol-create'
import OlHostFamilySinglePage from './ol-host-family-single-page'
import { OlListPage } from './ol-list'
import OlTeflViewPage from './ol-tefl-view'
import OlUpdatePage from './ol-update'
import OLTeachingHallGlobalListPage from './teaching-halls/teaching-hall-global-list'
import OLTeflGlobalListPage from './tefls/tefl-global-list'

const olRoutes: Route[] = [
  {
    path: Paths.OL_LIST_PAGE,
    element: <OlListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_CREATE_PAGE,
    element: <OlCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_DETAILS_PAGE,
    element: <OlUpdatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_HOST_FAMILY_INFORMATION,
    element: <OlHostFamilySinglePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_TEFL_DETAILS_PAGE,
    element: <OlTeflViewPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_COMMISSIONS_LIST_PAGE,
    element: <OlCommissionListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_COMMISSION_UPDATE_PAGE,
    element: <OlCommissionUpdatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_COMMISSION_CREATE_PAGE,
    element: <OlCommissionCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_TEACHING_HALL_VIEW_PAGE,
    element: <OlTeachingHallView />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_ACTIVITY_VIEW_PAGE,
    element: <OlActivityViewPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_COACH_COMPANIES_VIEW_PAGE,
    element: <OlCoachCompaniesViewPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_CENTER_LIST_PAGE,
    element: <OlCenterListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_CENTER_DETAILS_PAGE,
    element: <OlCenterDetails />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_COACH_COMPANIES_CREATE_PAGE,
    element: <OlCoachCompanyCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_HOST_FAMILY_GLOBAL_LIST_PAGE,
    element: <OLHostFamilyGlobalListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_TEACHING_HALL_GLOBAL_LIST_PAGE,
    element: <OLTeachingHallGlobalListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_TEFL_GLOBAL_LIST_PAGE,
    element: <OLTeflGlobalListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.OL_COACH_COMPANIES_GLOBAL_LIST_PAGE,
    element: <OLCoachCompaniesGlobalListPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default olRoutes
